<img src="/assets/images/login/dialog/close.svg" alt="Cerrar" class="close-icon" (click)="closeDialog()">
<div class="title" [innerHTML]="'pendingVerificationDialog_Data1' | i18n"></div>
<div class="description" [innerHTML]="'pendingVerificationDialog_Data2' | i18n: translationModes.INSERT_VALUE : email"></div>
<button [innerHTML]="'pendingVerificationDialog_Data3' | i18n" (click)="closeDialog(responses.RESEND)"></button>
